package pl.nickers.match3.ecs

internal class GravitySystem : BaseSystem() {
    override fun initialize() {}

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.GRAVITY) return
        if (world.getEntitiesForAspect(Aspect.all(FallingComponent::class)).isNotEmpty()) return

        applyGravityToGrid(world, emptySet(), board.width, board.height)
        if (world.getEntitiesForAspect(Aspect.all(FallingComponent::class)).isNotEmpty()) {
            board.didWork = true
        }
    }
}
